import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { FolioEnums } from 'src/app/utilities/folio-enums';
import { LabelConstants, AppConstants } from 'src/app/utilities/app-constants';

export interface FolioDialogModel {
  disableClose?: boolean;
  titleString?: string;
  messageString?: string;
  responseData?: string;
  placeholderString?: string;
  okButtonString?: string;
  cancelButtonString?: string;
  dialogType?: number;
  maxLength?: number;
}

@Component({
  selector: 'app-folio-dialog',
  templateUrl: './folio-dialog.component.html',
  styleUrls: ['./folio-dialog.component.css']
})
export class FolioDialogComponent implements OnInit {
  readonly MY_CONSTANT = LabelConstants;

  // content data ===== Data that is being injected into this dialog
  contentData: FolioDialogModel;
  // response data ===== Data that is being sent from this
  responseData: FolioDialogModel = {};

  dialogConfirmationControl = new FormControl('', [
    Validators.required,
  ]);
  nodeTypeSelectControl = new FormControl('', [
    Validators.required,
  ]);

  nodeTypeSelectData = [
    { key: AppConstants.PARAM_GO_JS_NODE_TYPE_EFFECT, value: AppConstants.PARAM_GO_JS_NODE_TYPE_EFFECT },
    { key: AppConstants.PARAM_GO_JS_NODE_TYPE_CAUSE, value: AppConstants.PARAM_GO_JS_NODE_TYPE_CAUSE },
    { key: AppConstants.PARAM_GO_JS_NODE_TYPE_SIBLING, value: AppConstants.PARAM_GO_JS_NODE_TYPE_SIBLING },
  ];

  constructor(
    private dialogRef: MatDialogRef<FolioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: FolioDialogModel
  ) { }
  myenums;

  ngOnInit() {
    this.myenums = FolioEnums;

    this.contentData = this.dialogData;

    if (this.contentData.dialogType === FolioEnums.folioDialogType.PROMPT) {
      if (this.contentData.responseData) {
        this.dialogConfirmationControl.setValue(this.contentData.responseData);
      }
    }
  }

  save() {
    let resultData: boolean | FolioDialogModel;

    // if type===PROMPT
    if (this.contentData.dialogType === FolioEnums.folioDialogType.PROMPT) {
      // , and the input field is invalid, just RETURN
      if (this.dialogConfirmationControl.invalid) {
        this.dialogConfirmationControl.markAsDirty();
        return;
      }

      // , and the input field is EMPTY or conatins only spaces, just RETURN
      if (this.dialogConfirmationControl.value.trim().length <= 0) {
        this.dialogConfirmationControl.setValue('');
        this.dialogConfirmationControl.markAsDirty();
        return;
      }

      // , and the input field is invalid, just RETURN
      this.responseData = {
        responseData: this.dialogConfirmationControl.value.trim(),
        dialogType: this.contentData.dialogType
      };
      resultData = this.responseData;
    } else if (this.contentData.dialogType === FolioEnums.folioDialogType.DROP_DOWN) {    // if type===DROP_DOWN
      if (this.nodeTypeSelectControl.invalid) {
        this.nodeTypeSelectControl.markAsDirty();
        return;
      }

      if (this.nodeTypeSelectControl.value.trim().length <= 0) {
        this.nodeTypeSelectControl.setValue('');
        this.nodeTypeSelectControl.markAsDirty();
        return;
      }

      this.responseData = {
        responseData: this.nodeTypeSelectControl.value.trim(),
        dialogType: this.contentData.dialogType
      };
      resultData = this.responseData;
    } else {
      resultData = true;
    }

    this.dialogRef.close(resultData);
  }

  close() {
    this.dialogRef.close(false);
  }

}
